import { apiClient } from "./apiClient";

const getUploadSignedUrl = async (path: string) => {
    const res = await apiClient.get(
      `/file/blobSignedUrl/upload?path=${path}`
    );
    return res.data;
};

export const storageService = {
    getUploadSignedUrl
}